import React, { useState, useEffect} from "react";
import "../style/dashboard.css";
import { Row, Col, Card, Table, Pagination, Alert, Spinner } from "react-bootstrap";
import HelperFunction from '../util/helper'
import { TIME_FORMAT_OPTIONS } from '../util/constants'
import { useSharedData } from "../context/sharedDataContext";

export default function PreviewTransactionsPage({ preview = false }) {

    const { data: user, loading } = useSharedData();

    if(loading) {
        return <div className="d-flex justify-content-center my-5">
                    <Spinner animation="border" />
                </div>
    }

    const transactions = HelperFunction.getSavingPlansTransactions(user)

    return(
        <Row>
            <Col>
                <Card className="transactions-card">
                    <Card.Body>
                        <div className="card-header-custom">
                            <h5><i className="bi bi-arrow-down-up"></i> Recent Transactions</h5>
                            <select className="filter-select">
                            <option>This Month</option>
                            <option>This Week</option>
                            <option>Today</option>
                            </select>
                        </div>
                        <Table responsive className="transactions-table">
                            <thead>
                                <tr>
                                    <th>Transaction Name</th>
                                    <th>Date & Time</th>
                                    <th>Amount</th>
                                    <th>Note</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                            {transactions.length > 0 ? (
                                transactions.map(transaction => (
                                    <tr key={transaction.id}>
                                    <td>
                                        <div className="transaction-info">
                                            <strong>{transaction.name}</strong>
                                            <small className="text-muted d-block">{transaction.category}</small>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="date-time">
                                            <div>{HelperFunction.formatDate(transaction.created_at, TIME_FORMAT_OPTIONS.DATE_MONTH_YEAR_OPTIONS)}</div>
                                            <small className="text-muted">{HelperFunction.formatDate(transaction.created_at, TIME_FORMAT_OPTIONS.TIME_OPTIONS)}</small>
                                        </div>
                                    </td>
                                    <td className={transaction.amount < 0 ? 'amount-negative' : 'amount-positive'}>
                                        {HelperFunction.formatCurrency(transaction.amount)}
                                    </td>
                                    <td className="note-cell">{HelperFunction.truncateString(transaction.description) ?? 'N/A'}</td>
                                    <td>{HelperFunction.getStatusBadge(transaction.status)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No transactions found.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                         </Table>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}